import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'preact/hooks'
import ArrowRightIcon from './icons/ArrowRightIcon'
import CheckInCircle from './icons/CheckInCircle'
import { useAppContext } from '../contexts/AppContext'
import { STEPS } from '../constants'
import useCompletionKeywordsState from '../hooks/useCompletionKeywordsState'

const SliderDashboard = ({ handleBrowClick, setProgress, isBrowOpened }) => {
  const { t } = useTranslation()
  const [slide, setSlide] = useState(null)
  const { viewMode, accentColor, acRootRef } = useAppContext()
  const finishButtonVisible = useCompletionKeywordsState()

  useEffect(() => {
    setSlide(window.AC_getStep?.())
  }, [])

  useEffect(() => {
    if (!slide) return
    const { stepsNumber } = slide
    const part = 100 / (stepsNumber + STEPS)

    const progress = part * slide.step

    if (slide.type === 'last') {
      handleBrowClick()
    }

    setProgress(progress + part)
  }, [slide])

  if (!slide && viewMode === 'funnel') return null

  const isFirst = slide?.type === 'first'
  const isLast = slide?.type === 'last'
  const isBrowHidden = slide?.type !== 'last' && viewMode === 'funnel'

  const handleNextBtnClick = () => {
    const currentStep = window.AC_getStep?.()
    const slides = acRootRef.current.getSlidesData?.()
    if (slides) {
      const slide = slides[currentStep.step]

      acRootRef.current.highlightElements?.(slide.requiredDataIds)

      if (!slides[currentStep.step]?.isFilled) return
    }

    setSlide(window.AC_next())
  }

  return (
    <div
      className={`absolute -top-[35px] flex  ${
        viewMode !== 'funnel' ? 'justify-center' : 'justify-between'
      }  left-0 right-0 z-[4]`}
    >
      <SliderButton isLeft disabled={isFirst || isBrowOpened} onClick={() => setSlide(window.AC_prev())}>
        {t('submit.backBtn', 'Back')}
      </SliderButton>
      <button
        type="button"
        onClick={handleBrowClick}
        style={{ background: accentColor, borderColor: accentColor }}
        className={`

          ${isBrowOpened || !finishButtonVisible ? 'hidden' : ''}
          ${isBrowHidden ? 'top-14' : 'top-0'}
          absolute left-1/2 -translate-x-[50%] transition-[top] max-[410px]:px-2
          flex items-center text-white outline-none justify-center rounded-tl-lg text-base
          border-[1px] border-transparent leading-6 bg-wp-dark py-[5px] px-7 rounded-tr-lg 
          dark:border-[1px] dark:text-white dark:bg-black !border-b-transparent dark:border-white
        `}
      >
        <div className="mr-2">
          <CheckInCircle />
        </div>

        <span>{t('submit.browLabel', 'Finish')}</span>
      </button>

      <SliderButton disabled={isLast || isBrowOpened} onClick={handleNextBtnClick}>
        {t('submit.nextBtn', 'Next')}
      </SliderButton>
    </div>
  )
}

const SliderButton = ({ disabled, isLeft, children, onClick }) => {
  const { viewMode, accentColor } = useAppContext()
  if (viewMode !== 'funnel') {
    return null
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{ background: accentColor, borderColor: accentColor }}
      className={`
        flex items-center justify-center bg-wp-bg-gray2 text-white px-[19px] py-[5px] hover:bg-wp-dark
        dark:border-[1px] dark:border-white dark:bg-wp-bg-gray3 max-[410px]:px-2 min-[410px]:min-w-[114px]
        ${isLeft ? 'rounded-tr-[5px]' : 'rounded-tl-[5px]'}
        ${disabled ? 'opacity-0 pointer-events-none' : ''}
      `}
    >
      {isLeft && (
        <div style="transform: rotate(180deg)" className={'mr-2'}>
          <ArrowRightIcon />
        </div>
      )}

      {children}

      {!isLeft && (
        <div className={'ml-2'}>
          <ArrowRightIcon />
        </div>
      )}
    </button>
  )
}

export default SliderDashboard
